import React from "react";

import { ExpressionView } from "../ExpressionView";

import {
    getExistsSimpleRule,
    getIfElseSimpleRule,
    getIfSimpleRule,
    getLogicExpression,
    getLogicExpressionElseIf,
    getLogicExpressionElseIfElseWithSub,
    getLogicExpressionElseIfElseWithSubWithBlanks,
    getLogicExpressionResultAtEnd,
    getLogicExpressionResultElseIfAtEnd,
    isFalseSimpleRule,
    isTrueSimpleRule,
    lessThanEqualToSimpleRule,
    lessThanSimpleRule,
    notSimpleRule,
} from "../Testing/LogicData";
import { expressionStoryData } from "../Testing/ExpressionData";
import { IfThenExpression } from "../../rule-engine-core/Expressions/Expressions/Logic/IfThenExpression";
import { getFilledDataDefinition } from "../../rule-engine-core/Common/Data/DataTestData";
import { StoryNode } from "../../CommonUI/StoryBook/StoryData";

export const ExpressionViewLogicStories = [
    new StoryNode(
        () => {
            let exp = getLogicExpression();
            exp.inputData = expressionStoryData;

            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Logic",
        "If Then",
    ),

    new StoryNode(
        () => {
            let exp = getLogicExpression();
            (exp.expression as IfThenExpression).showElseAsDefault = true;
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Logic",
        "If Then Default",
    ),
    new StoryNode(
        () => {
            let exp = getLogicExpressionElseIf();
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Logic",
        "If Then Else If",
    ),
    new StoryNode(
        () => {
            let exp = getLogicExpressionElseIf();
            exp.inputData = expressionStoryData;
            (exp.expression as IfThenExpression).thenText = "Bonus Paid Is";
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Logic",
        "If Then Else If Replaced Then",
    ),
    new StoryNode(
        () => {
            let exp = getLogicExpressionElseIf();
            exp.inputData = expressionStoryData;
            (exp.expression as IfThenExpression).showElseAsDefault = true;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Logic",
        "If Then Else If Default",
    ),
    new StoryNode(
        () => {
            let exp = getLogicExpressionElseIf();
            exp.inputData = expressionStoryData;
            (exp.expression as IfThenExpression).showElseAsDefault = true;
            (exp.expression as IfThenExpression).thenText = "company pays";
            (exp.expression as IfThenExpression).defaultText = "everyone else gets";
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Logic",
        "If Then Else If Default If",
    ),
    new StoryNode(
        () => {
            let exp = getLogicExpressionElseIfElseWithSub();
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Logic",
        "If Then Else If With Sub",
    ),
    new StoryNode(
        () => {
            let exp = getLogicExpressionElseIfElseWithSubWithBlanks();
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Logic",
        "If Then Else If Sub With Blanks",
    ),
    new StoryNode(
        () => {
            let exp = getLogicExpressionResultAtEnd();
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Logic",
        "If Then Results At End",
    ),
    new StoryNode(
        () => {
            let exp = getLogicExpressionResultElseIfAtEnd();
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Logic",
        "If Then Else If Results At End",
    ),
    new StoryNode(
        () => {
            let exp = getIfSimpleRule();
            exp.inputData = expressionStoryData;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Logic",
        "If Simple Rule",
    ),
    new StoryNode(
        () => {
            let exp = getIfSimpleRule();
            exp.inputData = expressionStoryData;
            (exp.expression as IfThenExpression).showSimpleReturn = false;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Logic",
        "If Simple Rule No Return",
    ),
    new StoryNode(
        () => {
            let exp = getIfElseSimpleRule();
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Logic",
        "If Else Simple Rule",
    ),
    new StoryNode(
        () => {
            let exp = getIfElseSimpleRule();
            (exp.expression as IfThenExpression).showSimpleReturn = false;
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Logic",
        "If Else Simple Rule No Return",
    ),
    new StoryNode(
        () => {
            let exp = getExistsSimpleRule();
            exp.inputData = () => {
                return getFilledDataDefinition();
            };
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Logic",
        "Exists Read Only",
    ),
    new StoryNode(
        () => {
            let exp = getExistsSimpleRule();
            exp.inputData = getFilledDataDefinition();
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Logic",
        "Exists Writable",
    ),
    new StoryNode(
        () => {
            let exp = isFalseSimpleRule();
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Logic",
        "If False Simple Rule",
    ),
    new StoryNode(
        () => {
            let exp = isTrueSimpleRule();
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Logic",
        "If True Simple Rule",
    ),
    new StoryNode(
        () => {
            let exp = lessThanSimpleRule();
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Logic",
        "Less Than",
    ),
    new StoryNode(
        () => {
            let exp = lessThanEqualToSimpleRule();
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Logic",
        "Less Than Equal To ",
    ),
    new StoryNode(
        () => {
            let exp = notSimpleRule();
            return <ExpressionView expression={exp}></ExpressionView>;
        },

        "Expression Builder",
        "Expression View",
        "Logic",
        "Not",
    ),
];
